<template>
    <div class="sidebar_right">
        <div id="datenschutz">
            <router-link to="/impressum">Impressum</router-link>
            <br /><router-link to="/datenschutz">Datenschutz</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SidebarRight',
    }
</script>